module.exports = __webpack_public_path__ + "img/wifi-3.3e4c6376.svg";